export default __webpack_public_path__ + "static/ayatori_tag-9c15e74d214a8d7cd59b6d3da2e4b569.jpg";